export default __webpack_public_path__ + "static/184-5b2b9b96086f062e9b6c465f0ce77877.jpg";